import { render, staticRenderFns } from "./VideoTipsToggle.vue?vue&type=template&id=5ac0c393&functional=true&"
import script from "./VideoTipsToggle.vue?vue&type=script&lang=js&"
export * from "./VideoTipsToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports